/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var ApiClient = require('../ApiClient');
var Category = require('./Category');
var CategoryEntries = require('./CategoryEntries');
var ResponsePagination = require('./ResponsePagination');




  /**
   * The CategoryPagedResponse model module.
   * @module model/CategoryPagedResponse
   * @version 1.4.0
   */

  /**
   * Constructs a new <code>CategoryPagedResponse</code>.
   * @alias module:model/CategoryPagedResponse
   * @class
   * @implements module:model/ResponsePagination
   * @implements module:model/CategoryEntries
   */
  var exports = function() {
    var _this = this;

    ResponsePagination.call(_this);
    CategoryEntries.call(_this);
  };

  /**
   * Constructs a <code>CategoryPagedResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CategoryPagedResponse} obj Optional instance to populate.
   * @return {module:model/CategoryPagedResponse} The populated <code>CategoryPagedResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      ResponsePagination.constructFromObject(data, obj);
      CategoryEntries.constructFromObject(data, obj);
    }
    return obj;
  };


  // Implement ResponsePagination interface:
  /**
   * The number of items returned in the response
   * @member {Number} pageSize
   */
exports.prototype['pageSize'] = undefined;

  /**
   * The current page number. Page number starts from 1.
   * @member {Number} pageNumber
   */
exports.prototype['pageNumber'] = undefined;

  /**
   * The total number of items that match the requirements specified in the request.
   * @member {Number} totalCount
   */
exports.prototype['totalCount'] = undefined;

  // Implement CategoryEntries interface:
  /**
   * @member {Array.<module:model/Category>} entries
   */
exports.prototype['entries'] = undefined;







module.exports = exports;